import { useDeleteConfirmationDialog } from '@mews-commander/ui';
import { LocalizedText, lt } from '@mews/framework';
import { IconButton, IconName } from '@optimus-web/core';
import { TextKey } from '@mews-commander/enums';
import { useAssignPropertyContext } from '../contexts';

interface Props {
    enterpriseId?: string;
    propertyGroupId?: string;
}

export const RemovePropertyButton = ({ enterpriseId, propertyGroupId }: Props) => {
    const { unassignProperties } = useAssignPropertyContext();
    const { confirmationDialog, openConfirmationDialog } = useDeleteConfirmationDialog({
        deleteAction: async () =>
            unassignProperties({
                ...(enterpriseId && { enterpriseIds: [enterpriseId] }),
                ...(propertyGroupId && { propertyGroupIds: [propertyGroupId] }),
            }),
        renderContent: () => lt('RemovePolicyFromPropertyDescription'),
        title: <LocalizedText textKey={TextKey.RemovePolicyFromPropertyTitle} substitutes={{ count: 1 }} />,
    });
    return (
        <>
            <IconButton
                icon={IconName.Delete}
                onClick={openConfirmationDialog}
                size="small"
                variant="ghost"
                type="submit"
            />
            {confirmationDialog}
        </>
    );
};
